import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-97c6651e")

_pushScopeId("data-v-97c6651e")
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "thumbnail" }
const _hoisted_3 = { class: "commands" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "これで制作", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ThumbnailSelectSample = _resolveComponent("ThumbnailSelectSample")
  const _component_modal = _resolveComponent("modal")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_ThumbnailSelectSample, { item: _ctx.thumbnailItem }, null, 8, ["item"]),
    _createVNode(_component_modal, {
      isShow: _ctx.isShowModal,
      "onUpdate:isShow": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowModal = $event)),
      isFitSize: true,
      onKeydown: _withKeys(_withModifiers(_ctx.toEdit, ["prevent"]), ["enter"])
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("img", {
              src: _ctx.thumbnailItem.imgPath
            }, null, 8, ["src"])
          ]),
          _createVNode("div", _hoisted_3, [
            _createVNode("button", {
              class: "app-button select-button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toEdit && _ctx.toEdit(...args)))
            }, [
              _hoisted_4
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["isShow", "onKeydown"])
  ]))
})